<template>
  <b-card no-body :class="{'p-3':true, 'text-center':true, 'percentBG':this.cardData.postfix}" style="height: 150px;">
    <b-row align-v="center" align-h="center">
      <b-col>
        <h6 class="my-2">{{ cardData.label }}</h6>
      </b-col>
    </b-row>
    <b-row class="h-100 font-weight-bolder" align-v="center" align-h="center">
      <b-spinner v-if="loading"/>
      <template v-else align-v="center" align-h="center">
        <div class="mb-3 pr-1">{{cardData.prefix}}</div>
        <div class="font-size-h2 ">{{formatedValue}}</div>
        <div class="mt-3 pl-1"> {{cardData.postfix}}</div>
      </template>
    </b-row>
    <b-row align-v="center" align-h="center">
        <div v-if="loading" style="opacity: 0;">Loading...</div>
        <b-row v-else-if="cardData.difference" align-v="center"
          v-b-tooltip.hover.bottomright.html="toolTipText"
          :style="{'font-size':'14px !important',color: cardData.difference >= 0? increaseColor : decreaseColor}">
          <i class="material-icons" style="color:inherit;font-size:inherit">timeline</i>
          <div class="font-weight-bolder mx-2">{{ formatThousands(cardData.difference) }}%</div>
          <i class="material-icons" style="color:inherit;font-size:inherit">
            <template v-if="cardData.difference >= 0">arrow_upward</template>
            <template v-else>arrow_downward</template>
          </i>
        </b-row>
        <div v-else-if="cardData.difference !== null" class="font-weight-bold font-size-h6"> - </div>
        <div v-else style="opacity: 0;"> - </div>
    </b-row>
  </b-card>
</template>
<script>
export default {
  name: "kpi-card",
  props: {
    cardData: {
      type: Object,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data(){
    return {
      increaseColor: "#54b854",
      decreaseColor: "#ee7474",
    }
  },
  computed:{
    formatedValue:function(){
      if(this.cardData.prefix && this.cardData.prefix == "AED"){
        return this.formatTableCurrency(this.cardData.kpi_value)
      }else{
        return this.formatThousands(this.cardData.kpi_value)
      }
    },
    toolTipText: function(){
      if(this.cardData.previous_value === this.cardData.kpi_value){
        return `No Change`
      }
      let forcast = ''
      if(this.cardData.forcast){
        forcast = `Expected to reach ${this.cardData.forcast}<br>`
      }
      const previousText=`${this.cardData.difference <0 ? 'Down': 'Up'} from ${this.formatThousands(this.cardData.previous_value)} in previous period`
      return forcast+previousText
    }
  },
  methods:{
    formatThousands(amount) {
    const formattedAmount = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(amount);

    let splitAmount = formattedAmount.split(".");
    return splitAmount[1] > 0 ? formattedAmount : splitAmount[0];
  },
    formatTableCurrency(amount) {
      
        const formattedAmount = new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
          notation: 'compact'
        }).format(amount);
        return formattedAmount;
      
    },
  }
};
</script>
<style lang="scss" scoped>
.percentBG {
  background-color: #eeeef8;
}
</style>